import * as React from "react";
import { attributeMap } from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/AttributeMap/AttributeMap";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { FilterByAttributeOptions } from "source/app/presentation/MainPanel/Dreams/Filter/FilterByAttributeOptions";

export function FilterByAttribute({
    style,
    onChange,
    selectedAttribute,
}: FilterByAttributeOptions) {
    return (
        <div id="emotionSelector">
            <FormSelect
                id="attribute"
                label="Attribute"
                width="100%"
                classes={style}
                suggestions={attributeMap.map(
                    (att) => EDA[att.attribute]
                )}
                onChange={onChange}
                value={selectedAttribute} />
        </div>
    );
}
